<template>
  <v-card style="border-radius:10px">
    <!-- <v-flex xs12 v-if="showFood" style="text-align:left;">
      <v-chip
        @click="$router.push({name: 'searchFoodDetail', params: {id: post.food.id}})"
        label small color="grey" text-color="white" style="min-width:120px;">
        <v-icon left>label</v-icon>{{post.food.name}}
      </v-chip>
    </v-flex> -->
    <div style="padding:0 5px;">
      <div @click="onCardClick('card')">
        <!-- アイコン画像／ユーザー名／投稿時間 -->
        <v-card-title style="padding-bottom:0;">
          <!-- <v-avatar size="34"><img :src="post.user.imageurl"></v-avatar> -->
          <v-avatar size="36" style="z-index:2;"><v-img :src="post.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/></v-avatar>
          <div style="height:40px;width:40px;border-radius:20px;border:solid 2px #f44336;position:absolute;top:14px;left:19px;"></div>
          <span class="subheading" style="margin-left:10px;font-weight:bold;">{{post.user.displayName | textTrim(16)}}</span>
          <!-- <v-spacer></v-spacer> -->
          <!-- <span style="font-size:90%;color:#666;">{{post.timestamp | displayDate}}</span> -->
        </v-card-title>
        <!-- ／アイコン画像／ユーザー名／投稿時間 -->
        <v-card-text xs12 style="text-align:left;padding-bottom:0;">
          <p v-html="$options.filters.changeBR(post.content)" class="content"></p>
          <lazy-component @show="onShow"></lazy-component>
          <div v-if="isShow">
            <v-layout v-if="post.images.length==1" row wrap style="margin-bottom:16px;">
              <v-flex xs12>
                <!-- <v-img v-lazy:background-image="imageurls[0]" aspect-ratio="1.5" max-height="36vh" style="background-position: center center;"></v-img> -->
                <v-img :src="imageurls[0]" aspect-ratio="1.5" max-height="36vh" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
              </v-flex>
            </v-layout>
            <v-layout v-else-if="post.images.length==2" row wrap style="margin-bottom:16px;">
              <v-flex xs6 v-for="(imageurl, id) in imageurls" :key=id style="padding:1px;">
                <v-img :src="imageurl" aspect-ratio="1" max-height="36vh" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
              </v-flex>
            </v-layout>
            <v-layout v-else-if="post.images.length==3 && imageurls.length==3" style="margin-bottom:16px;">
              <v-flex xs6 style="padding:1px;">
                <v-img :src="imageurls[0]" aspect-ratio="0.75" max-height="36vh" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
              </v-flex>
              <v-flex xs6>
                <v-flex xs12 style="padding:1px;">
                  <v-img :src="imageurls[1]" aspect-ratio="1.5" max-height="18vh" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
                </v-flex>
                <v-flex xs12 style="padding:1px;">
                  <v-img :src="imageurls[2]" aspect-ratio="1.5" max-height="18vh" :lazy-src="require('@/assets/img/icon_loader.gif')"></v-img>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="isYoutube" style="margin-bottom:16px;">
              <youtube v-if="isYoutube" width="100%" :video-id="youtubeId" :resize=true></youtube>
            </v-flex>
            <v-flex xs12 v-if="isTwitter" style="margin-bottom:16px;">
              <Tweet :id="tweetId"></Tweet>
            </v-flex>
            <p v-if="showFood && isFood">
              <food-card-min 
              @onFoodCardMinClick="$router.push({name: 'searchFoodDetail', params: {id: post.food.id}})"
              :imageurl="foodImageUrl" :name="post.food.name"></food-card-min>
            </p>
            <p v-if="showFood && isShop">
              <shop-card-min 
              @onClick="$router.push({name: 'ShopDetail', params: {id: post.shop.id}})"
              label="カラログした飲食店"
              :shop="post.shop" 
              ></shop-card-min>
            </p>
          </div>
          <p v-if="post.rating">
            <v-chip small label outline color="primary" text-color="primary">
              辛さ：<v-icon small>star</v-icon>{{post.rating.hot}}
            </v-chip>
            <v-chip small label outline color="primary" text-color="primary">
              味：<v-icon small>star</v-icon>{{post.rating.taste}}
            </v-chip>
          </p>
        </v-card-text>
      </div>
      <v-flex xs12 style="text-align:right;margin-right:16px;padding-bottom:16px;">
          <v-btn icon small color="primary" flat @click="onCardClick('comment')"><v-icon>chat_bubble_outline</v-icon>
            <span v-if="post.commentCount">{{post.commentCount}}</span>
          </v-btn>
          <v-btn icon small color="primary" flat @click="onLike">
            <v-icon v-if="isLike">favorite</v-icon>
            <v-icon v-else>favorite_border</v-icon>          
            {{post.likes.length}}
          </v-btn>
      </v-flex>
    </div>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import {db} from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'
import {Tweet} from 'vue-tweet-embed'
import FoodCardMin from '@/components/card/FoodCardMin.vue'
import ShopCardMin from '@/components/card/ShopCardMin.vue'

export default {
  name: 'PostCard',
  data () {
    return {
      imageurls: [],
      foodImageUrl: '',
      isYoutube: false,
      youtubeId: '',
      isTwitter: false,
      tweetId: '',
      isFood: false,
      isShop: false,
      isShow: false
    }
  },
  props: {
    post: Object,
    showFood: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isLike () {
      return this.post.likes.includes(this.user.uid)
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  filters: {
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    },
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    },
    changeBR (v) {
      let max = 100
      if (v.length >= max) v =  v.substring(0, max - 1) + '...　<a href="#">続きを見る</a>'
      return v.replace(/\r?\n/g, '<br>')
    }
  },
  created () {
    if (this.showFood) {
      if (this.post.food) {
        this.showFood = true
        this.getFoodImageUrl()
      }
    }
    if (this.post.mode === 'food' || this.post.mode === 'free') {
      this.isFood = true
    } else if (this.post.mode === 'shop') {
      this.isShop = true
    }
  },
  mounted () {
    if (!this.post.imageurls) {
      this.getImageUrl()
    } else {
      this.imageurls = this.post.imageurls
    }
    if (this.post.referURL) {
      // youtube対応
      let url = this.post.referURL
      let p1 = 'https://www.youtube.com/watch?v='
      let p2 = 'https://youtu.be/'
      if (url.indexOf(p1) !== -1) {
        let id = url.split('v=')[1]
        this.isYoutube = true
        this.youtubeId = id
      } else if (url.indexOf(p2) !== -1) {
        let id = url.split('be/')[1]
        this.isYoutube = true
        this.youtubeId = id
      }
      // Twitter対応
      url = this.post.referURL
      p1 = 'https://twitter.com/'
      if (url.indexOf(p1) !== -1) {
        let id = url.split('/status/')[1]
        this.isTwitter = true
        this.tweetId = id
      }
    }
  },
  methods: {
    onShow() {
      this.isShow = true
    },
    getImageUrl () {
      if (this.images !== undefined) {
        this.imageurls = this.images
        return
      }
      if (this.post.images === undefined) return
      this.post.images.forEach(path => {
        let url = getImageUrl.get('post', this.post.id, path)
        this.imageurls.push(url)
        this.imageurls.sort(function (a, b) {
          if( a < b ) return -1;
          if( a > b ) return 1;
          return 0;
        })
      })
    },
    getFoodImageUrl () {
      this.foodImageUrl = getImageUrl.get('food_thumbs', this.post.food.id, this.post.food.imageurl)
    },
    onCardClick (position) {
      this.$emit('onReviewCardClick', this.post, position)
    },
    onLike () {
      if (!this.isLogin) {
        let message = {
          group: 'messageBottom',
          type: 'warning',
          title: 'ログインが必要です',
          text: 'ログインしていいねしよう！'
        }
        this.$emit('onMessage', message)
        return
      }
      if (this.isLike) {
        // いいね済⇒いいね削除
        return
        // let index  = this.post.likes.findIndex(t => t === this.user.uid)
        // this.post.likes.splice(index, 1)
        // db.collection('post').doc(this.post.id).update({
        //   'likes': firebase.firestore.FieldValue.arrayRemove(this.user.uid)
        // })
      } else {
        // いいね追加
        this.post.likes.push(this.user.uid)
        db.collection('post').doc(this.post.id).update({
          'likes': firebase.firestore.FieldValue.arrayUnion(this.user.uid)
        })
      }
    }
  },
  components: {
    Tweet,
    FoodCardMin,
    ShopCardMin
  }
}
</script>

<style scoped>
  .VueCarousel-dot--active {
    background-color: #f44336 !important;
  }
  .content {
    font-weight: bold;
    font-size: 11pt;
  }
</style>